module.exports = __webpack_public_path__ + "static/media/day06_align.d98004df.gif";